"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Fonts_1 = require("./Fonts");
var URL = 'https://static.vente-privee.com/vp5/fonts/';
/*
  woff2: super modern browsers (no ie11 support)
  woff: "modern" browsers (ie11 support)
 */
var fontFaceLite = function (family, path, weight, style) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @font-face {\n    font-family: ", ";\n    src: url(", "", ".woff2) format('woff2'), url(", "", ".woff) format('woff');\n    font-weight: ", ";\n    font-style: ", ";\n  }\n"], ["\n  @font-face {\n    font-family: ", ";\n    src: url(", "", ".woff2) format('woff2'), url(", "", ".woff) format('woff');\n    font-weight: ", ";\n    font-style: ", ";\n  }\n"])), family, URL, path, URL, path, weight, style); };
var FontsLite = Fonts_1.getFontFaces(fontFaceLite);
exports.default = FontsLite;
var templateObject_1;
